export default {"src":"/images/2.jpg","width":750,"height":1000,"aspectRatio":0.75};